import React from 'react';
import ReactDOM from 'react-dom';
import './index.css'
import Wrapper from "./component/Wrapper";

ReactDOM.render(
  <React.StrictMode>
      <Wrapper/>
  </React.StrictMode>,
  document.getElementById('root')
);
